import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import FooterLogo from './FooterLogo';
import QuickLinks from './QuickLinks';
import ContactInfo from './ContactInfo';
import SocialLinks from './SocialLinks';
import FooterBottom from './FooterBottom';
import './Footer.css';

const Footer: React.FC = () => {
  const { isRTL } = useLanguage();

  return (
    <footer className={`footer ${isRTL ? 'rtl' : 'ltr'}`}>
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            {/* Top Row: Quick Links and Contact Info side by side */}
            <div className="footer-top-row">
              {/* Quick Links Section */}
              <div className="footer-section links-section">
                <QuickLinks />
              </div>

              {/* Contact Info Section */}
              <div className="footer-section contact-section">
                <ContactInfo />
              </div>
            </div>

            {/* Bottom Row: Social Links full width */}
            <div className="footer-section social-section">
              <SocialLinks />
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <FooterBottom />
    </footer>
  );
};

export default Footer;
